var map = {
	"./adventure1.mp3": 68444,
	"./adventure2.mp3": 82407,
	"./adventure3.mp3": 18391,
	"./adventure4.mp3": 41466,
	"./adventure5.mp3": 45212,
	"./adventure6.mp3": 41980
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31289;